import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import DatabaseValue from '../../components/Database/models/Value';
import getDefaultValue from './getDefaultValue';
import templates from './templates';

function init(ops) {
  return DatabaseValue.create(ops);
}

export default function provideLocalDatabaseSync(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(ComponentWithDatabaseValue, _Component);

    function ComponentWithDatabaseValue() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, ComponentWithDatabaseValue);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ComponentWithDatabaseValue)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onInit", function () {
        var value = templates[_this.props.databaseNoteId] ? init(templates[_this.props.databaseNoteId]) : init(_this.props.value || getDefaultValue());

        _this.setState({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onLocalChange", function (_ref) {
        var value = _ref.value,
            operations = _ref.operations,
            selection = _ref.selection,
            data = _ref.data;

        _this.setState({
          value: value,
          selection: selection,
          data: data
        });

        console.warn('Editor - Database - We are just logging changes, nothing is remotely saved', {
          value: value,
          operations: operations,
          selection: selection,
          data: data
        });

        _this.props.onChange({
          value: value,
          operations: operations,
          selection: selection,
          data: data
        });
      });

      return _this;
    }

    _createClass(ComponentWithDatabaseValue, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        console.warn('Editor - You are using databases without remote syncing. Use it only for development.');
        this.onInit();
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, Object.assign({}, this.props, this.state, {
          onChange: this.onLocalChange,
          onError: this.context.onError
        }));
      }
    }]);

    return ComponentWithDatabaseValue;
  }(Component), _defineProperty(_class, "displayName", "provideLocalDatabaseSync(".concat(WrappedComponent.name || WrappedComponent.displayName, ")")), _defineProperty(_class, "defaultProps", {
    onChange: function onChange() {}
  }), _temp;
}